module.exports = __webpack_public_path__ + "static/media/Calendar-1.fc84ebe7.jpeg";